<template>
    <div class="o-highlights__container" v-bind:class="{'o-highlights__container--unloading-mobile': unloading}">
        <div class="o-media" v-bind:class="{'o-media--active': media_active, 'o-media--unloading': unloading }">
            <img class="o-media__object" :src="$route.meta.image">
        </div>
        <div class="o-highlights__content" v-bind:class="{'o-highlights__content--unloading': unloading }">
            <div class="o-container">
                <div v-if="$route.meta.heading" class="o-row" data-aos="fade-left" data-aos-delay="900" data-aos-duration="600">
                    <div :class="heading_alignment">
                        <h1 class="o-highlights__headline" v-html="$route.meta.heading"></h1>
                    </div>
                </div>
                <div v-if="$route.meta.caption || has_cta" class="o-row" data-aos="fade-left" data-aos-delay="1100" data-aos-duration="600">
                    <div class="o-col-lg-5 o-col-xxl-6 o-offset-lg-6">
                        <p v-if="$route.meta.caption" class="o-highlights__caption" v-html="$route.meta.caption"></p>
                        <div class="c-button__group" v-if="has_cta">
                            <cta-button v-for="(cta, index) in $route.meta.ctas" :href="cta.url" :label="cta.label" :icon="cta.icon" :key="index.toString()"></cta-button>
                        </div>
                        <home-button :location="'mobile'"></home-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            media_active: false,
        }
    },
    mounted() {

        setTimeout(() => {
            this.media_active = true;
        }, 100);
    },
    computed: {
        heading_alignment: function() {
            return this.$route.meta.heading_alignment == 'caption' ? 'o-col-lg-5 o-col-xxl-6 o-offset-lg-6' : 'o-col-lg-7 o-col-xxl-8 o-offset-lg-4';
        },
        has_cta: function() {
            return this.$route.meta.ctas.length > 0
        }
    },
}
</script>
